"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Priority;
(function (Priority) {
    Priority["HIGH_VALUE_RENEWABLE_WITH_CHURN_RISK"] = "renewal_valuable_customer_risk";
    Priority["UPSELL_WITH_MEDIUM_OR_HIGH_CHURN_OR_ACQ"] = "upsell_valuable_customer_risk";
    Priority["VALUABLE_RENEWAL_WITH_LOW_RISK"] = "renewal_valuable_customer_low_risk";
    Priority["NO_RESULT"] = "no_result";
})(Priority || (Priority = {}));
exports.default = Priority;
